import { BuildingsIcon } from "@phosphor-icons/react";
import { GlobalToken, Select, SelectProps } from "antd";
import { useAntTheme } from "hooks/useAntTheme";
import { useEffect, useState } from "react";
import { useBoundStore } from "store";
import styled from "styled-components";
import { useSession } from "hooks/useSession";
import { useAuthActions } from "hooks/useAuthActions";

export const OrganizationSwitch = () => {
  const { organizations, currentOrganization: organization } = useSession();
  const { selectOrganization } = useAuthActions();
  const { theme } = useAntTheme();
  const [ready, setReady] = useState(false);
  useEffect(() => {
    setTimeout(() => setReady(true), 1000); // hack to avoid picker value flickering on page load
  }, []);

  const setAppState = useBoundStore((state) => state.setAppState);

  if (organization?.name === null) return null;
  return (
    <StyledSelect
      data-testid="OrganizationSwitch"
      showSearch
      optionFilterProp="label"
      loading={!organizations?.length && !ready}
      theme={theme}
      size="large"
      disabled={organizations?.length < 2}
      onChange={(value) => {
        selectOrganization(value);
        setAppState({ workspace: null });
      }}
      value={ready && organization?.id}
      options={organizations?.map(({ id, name }) => {
        return {
          value: id,
          label: name,
        };
      })}
      style={{ width: "100%" }}
      virtual={false} // disable for automated pass to find test org
      suffixIcon={<BuildingsIcon size={20} weight="bold" />}
    />
  );
};

const StyledSelect = styled(Select)<SelectProps & { theme: GlobalToken }>`
  .ant-select-selector {
    border-width: 2px !important;
    box-shadow: none !important;
  }
  &:not(.ant-select-focused) {
    .ant-select-selector {
      color: ${({ theme }) => theme.colorPrimary} !important;
    }
  }
`;
